(function () {
  const initAnnouncementBar = () => {
    document.querySelectorAll(".announcement-bar__swiper").forEach((el) => {
      if (el.classList.contains("swiper-initialized")) return;

      const delay = parseInt(el.dataset.autoplayDelay) || 5000;
      const playPauseButton = el.querySelector('.announcement-bar__play-pause');
      const progressCircle = playPauseButton?.querySelector('.announcement-bar__progress-circle');

      if (!playPauseButton || !progressCircle) return;

      let isPaused = false;
      let progressAnimation = null;

      progressCircle.style.strokeDasharray = '53.407';
      progressCircle.style.strokeDashoffset = '53.407';
      progressCircle.style.strokeOpacity = '0.5';
      progressCircle.style.strokeWidth = '1';

      const startProgress = () => {
        progressAnimation?.cancel();
        progressAnimation = progressCircle.animate(
          [
            {
              strokeDashoffset: '53.407',
              strokeOpacity: '0.5',
              strokeWidth: '1',
            },
            {
              strokeDashoffset: '0',
              strokeOpacity: '1',
              strokeWidth: '1.5',
            },
          ],
          {
            duration: delay,
            easing: 'linear',
            fill: 'forwards',
          }
        );

        if (!isPaused) {
          playPauseButton.classList.add('is-playing');
          return;
        }

        progressAnimation.pause();
      };

      const swiper = new Swiper(el, {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        speed: 800,
        direction: "vertical",
        loop: true,
        allowTouchMove: true,
        spaceBetween: 0,
        slidesPerView: 1,
        autoplay: {
          delay: delay,
          disableOnInteraction: false,
        },
        on: {
          init: function() {
            startProgress();
          },
          slideChange: function() {
            startProgress();
          },
        },
      });

      playPauseButton.addEventListener('click', () => {
        if (isPaused) {
          isPaused = false;
          playPauseButton.classList.add('is-playing');
          playPauseButton.classList.remove('is-paused');
          progressAnimation?.play();
          if (swiper.autoplay.resume) {
            swiper.autoplay.resume();
          } else {
            swiper.autoplay.start();
          }
        } else {
          isPaused = true;
          playPauseButton.classList.add('is-paused');
          progressAnimation?.pause();
          if (swiper.autoplay.pause) {
            swiper.autoplay.pause();
          } else {
            swiper.autoplay.stop();
          }
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", initAnnouncementBar);
  document.addEventListener("shopify:section:load", initAnnouncementBar);
})();
